// Base URL for backend API calls. In prod this is set at build time to the
// API Gateway custom domain (https://api.conveyo.one — see
// .github/workflows/deploy.yml); everywhere else (local dev, LocalStack, and
// any environment without its own api.* domain) it falls back to the
// same-origin /api/* path that vite.config.ts's dev proxy and CloudFront's
// /api/* behavior both handle.
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'
